export default import.meta.ROLLUP_FILE_URL_zOyQqdNGsn0lL_XEFrarVA;